export class Ads {
    id: number;
    name: string;
    Starts_at: string;
    Ends_at: string;
    Image: string;
}